export const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function moveItemBetweenUsers(selectedUserId, reassignModalData, agencies) {
    const { applicationId, userId, agencyId } = reassignModalData
    // Find the source user and the item to be moved
    const sourceAgency = agencies.find((agency) => agency.id === agencyId)
    const sourceUser = sourceAgency.contacts.find((user) => user.id === userId)
    const itemIndex = sourceUser.applications.findIndex((item) => item.id === applicationId)

    if (itemIndex === -1) {
        console.error(`Item with id ${applicationId} not found in the source user's items.`)
        return agencies // Return the original agencies array since no changes were made.
    }

    const itemToMove = sourceUser.applications.splice(itemIndex, 1)[0]

    // Find the destination user and move the item to their items
    const destinationUser = sourceAgency.contacts.find((user) => user.id == selectedUserId)

    if (!destinationUser) {
        console.error(`User with id ${selectedUserId} not found in the agency.`)
        return agencies // Return the original agencies array since no changes were made.
    }

    destinationUser.applications.push(itemToMove)
    return {
        userId: destinationUser.id,
        id: applicationId
    }
}

export const isGreaterOrLessThanSixtyDays = (dateExpiration) => {
    const today = new Date()
    const expiration = new Date(dateExpiration)
    const isPreviousDate = expiration.getTime() < today.getTime()
    const difference = expiration.getTime() - today.getTime()
    const differenceInDays = difference / (1000 * 3600 * 24)
    if (isPreviousDate && Math.abs(differenceInDays) <= 60) {
        return true
    } else if (!isPreviousDate) {
        return true
    } else {
        return false
    }
}

export const Roles = {
    Admin: "Admin",
    Standard: "Standard",
    SuperAdmin: "Super Admin"
}

export const questionnaire = [
    {
        number: 8,
        question: "Are any operations performed outside of the United States?",
        name: "operationsPerformedOutsideOfUs"
    },
    {
        number: 9,
        question:
            "Within the last five (5) years has the applicant purchased Professional Liability or Contractor Pollution Liability Insurance coverage?",
        name: "hasPurchasedProfessionalLiabilityOrContractorPollutionLiabilityInsurance"
    },
    {
        number: 10,
        question:
            "Within the last five (5) years have any claims been made or legal actions (including regulatory actions) been brought against any prospective Insureds?",
        name: "hasClaimsOrLegalActionsAgainstInsureds",
        explanationRequired: true
    },
    {
        number: 11,
        question:
            "Within the last five (5) years have any of the prospective Insureds been involved in any pollution incidents?",
        name: "hasPollutionIncidents",
        explanationRequired: true
    },
    {
        number: 12,
        question:
            "Do the prospective Insureds have any knowledge of damage or injury to property, the environment or people during the last five (5) years that was or may in any way have been attributable to them?",
        name: "hasDamageOrInjuryToProperty",
        explanationRequired: true
    },
    {
        number: 13,
        question:
            "At the time of signing this application, are the prospective Insureds aware of any circumstances that may reasonably be expected to give rise to a claim against any insured or otherwise generate a request for coverage under this Policy?",
        name: "hasCircumstancesToGiveRiseToClaim",
        explanationRequired: true
    }
]

export const columnLabels = [
    "Air Conditioning, Fire Proofing",
    "Asbestos Abatement, Fire Restoration",
    "Concrete, Flooring",
    "Demolition, General Contractor",
    "Dredging, Glazier",
    "Drilling(other than horizontal drilling for utilities), HVAC",
    "Drywall, Highway",
    "Electrical, Industrial Cleaning / Maintenance",
    "Elevator Services, Insulation",
    "Environmental Contracting, Landscaping",
    "Excavation/Grading, Marine Services",
    "Exterminator, Masonry",
    "Farming/Agricultural Services, Mechanical",
    "Fencing, Mold Abatement",
    "Oilfield / Gas Well Services, Steel Erection",
    "Painting, Tank Installation / Repair",
    "Road and Street Paving, Telecommunications",
    "Pipeline Installation / Maintenance, Tree Services",
    "Plumbing, Utility – Sewer, water & gas",
    "Roofing, Other (please describe)",
    "Solar and Alternative Energy"
]

export const formatDate = (date, includeTime = false) => {
    if (!date) {
        return ""
    } else if (!(date instanceof Date)) {
        date = new Date(date)
    }

    const options = {
        timeZone: "America/New_York", // Eastern Time Zone
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }

    if (includeTime) {
        options.hour = "2-digit"
        options.minute = "2-digit"
        options.second = "2-digit"
        options.hour12 = true // For 12-hour clock format
    }

    return Intl.DateTimeFormat("en-US", options).format(date)
}

export function sortAgenciesByName(dataArray) {
    return dataArray.slice().sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
    })
}

export function downloadFile(file) {
    // check if the file.file is correctly encoded
    if (!file.file) {
        console.error("File content is empty.")
        return
    }
    const decodedContent = atob(file.file)
    const uint8Array = new Uint8Array(decodedContent.length)
    for (let i = 0; i < decodedContent.length; i++) {
        uint8Array[i] = decodedContent.charCodeAt(i)
    }
    const blob = new Blob([uint8Array], { type: file?.mimeType })
    const blobUrl = URL.createObjectURL(blob)
    const downloadLink = document.createElement("a")
    downloadLink.href = blobUrl
    downloadLink.download = file?.fileName || "file"
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
    URL.revokeObjectURL(blobUrl)
}

export function camelCaseToWords(str) {
    if (!str) return ""
    return str.replace(/([A-Z])/g, " $1").trim()
}

export const poBoxRegex =
    // eslint-disable-next-line no-useless-escape
    /^ *((#\d+)|((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(#|n|num|number)?\d+))|(p(ost|ostal)? *(o(ff(ice)?)?)? *((box|bin)|b)? *(#|n|num|number)*\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(#|n|num|number)? *\d+|(#|n|num|number) *\d+)/i

export const authRoutes = [
    "/forgot-password",
    "/reset-password",
    "/complete-registration",
    "/agency/login-mfa",
    "/admin/login-mfa",
    "/agency/login",
    "/admin/login"
]

export const contractingServices = [
    {
        id: "00000000-0000-0000-0000-000000000001",
        name: "Air Conditioning",
        key: "contractingServiceAirConditioning"
    },
    {
        id: "00000000-0000-0000-0000-000000000002",
        name: "Fire Proofing",
        key: "contractingServiceFireProofing"
    },
    {
        id: "00000000-0000-0000-0000-000000000003",
        name: "Asbestos Abatement",
        key: "contractingServiceAsbestosAbatement"
    },
    {
        id: "00000000-0000-0000-0000-000000000004",
        name: "Fire Restoration",
        key: "contractingServiceFireRestoration"
    },
    {
        id: "00000000-0000-0000-0000-000000000005",
        name: "Concrete",
        key: "contractingServiceConcrete"
    },
    {
        id: "00000000-0000-0000-0000-000000000006",
        name: "Flooring",
        key: "contractingServiceFlooring"
    },
    {
        id: "00000000-0000-0000-0000-000000000007",
        name: "Demolition",
        key: "contractingServiceDemolition"
    },
    {
        id: "00000000-0000-0000-0000-000000000008",
        name: "General Contractor",
        key: "contractingServiceGeneralContractor"
    },
    {
        id: "00000000-0000-0000-0000-000000000009",
        name: "Dredging",
        key: "contractingServiceDredging"
    },
    {
        id: "00000000-0000-0000-0000-000000000010",
        name: "Glazier",
        key: "contractingServiceGlazier"
    },
    {
        id: "00000000-0000-0000-0000-000000000011",
        name: "Drilling(other than horizontal drilling for utilities)",
        key: "contractingServiceDrilling"
    },
    {
        id: "00000000-0000-0000-0000-000000000012",
        name: "HVAC",
        key: "contractingServiceHvac"
    },
    {
        id: "00000000-0000-0000-0000-000000000013",
        name: "Drywall",
        key: "contractingServiceDrywall"
    },
    {
        id: "00000000-0000-0000-0000-000000000014",
        name: "Highway",
        key: "contractingServiceHighway"
    },
    {
        id: "00000000-0000-0000-0000-000000000015",
        name: "Electrical",
        key: "contractingServiceElectrical"
    },
    {
        id: "00000000-0000-0000-0000-000000000016",
        name: "Industrial Cleaning / Maintenance",
        key: "contractingServiceIndustrialCleaningMaintenance"
    },
    {
        id: "00000000-0000-0000-0000-000000000017",
        name: "Elevator Services",
        key: "contractingServiceElevatorServices"
    },
    {
        id: "00000000-0000-0000-0000-000000000018",
        name: "Insulation",
        key: "contractingServiceInsulation"
    },
    {
        id: "00000000-0000-0000-0000-000000000019",
        name: "Environmental Contracting",
        key: "contractingServiceEnvironmentalContracting"
    },
    {
        id: "00000000-0000-0000-0000-000000000020",
        name: "Landscaping",
        key: "contractingServiceLandscaping"
    },
    {
        id: "00000000-0000-0000-0000-000000000021",
        name: "Excavation/Grading",
        key: "contractingServiceExcavationGrading"
    },
    {
        id: "00000000-0000-0000-0000-000000000022",
        name: "Marine Services",
        key: "contractingServiceMarineServices"
    },
    {
        id: "00000000-0000-0000-0000-000000000023",
        name: "Exterminator",
        key: "contractingServiceExterminator"
    },
    {
        id: "00000000-0000-0000-0000-000000000024",
        name: "Masonry",
        key: "contractingServiceMasonry"
    },
    {
        id: "00000000-0000-0000-0000-000000000025",
        name: "Farming/Agricultural Services",
        key: "contractingServiceFarmingAgriculturalServices"
    },
    {
        id: "00000000-0000-0000-0000-000000000026",
        name: "Mechanical",
        key: "contractingServiceMechanical"
    },
    {
        id: "00000000-0000-0000-0000-000000000027",
        name: "Fencing",
        key: "contractingServiceFencing"
    },
    {
        id: "00000000-0000-0000-0000-000000000028",
        name: "Mold Abatement",
        key: "contractingServiceMoldAbatement"
    },
    {
        id: "00000000-0000-0000-0000-000000000029",
        name: "Oilfield / Gas Well Services",
        key: "contractingServiceOilfieldGasWellServices"
    },
    {
        id: "00000000-0000-0000-0000-000000000030",
        name: "Steel Erection",
        key: "contractingServiceSteelErection"
    },
    {
        id: "00000000-0000-0000-0000-000000000031",
        name: "Painting",
        key: "contractingServicePainting"
    },
    {
        id: "00000000-0000-0000-0000-000000000032",
        name: "Tank Installation / Repair",
        key: "contractingServiceTankInstallationRepair"
    },
    {
        id: "00000000-0000-0000-0000-000000000033",
        name: "Road and Street Paving",
        key: "contractingServiceRoadAndStreetPaving"
    },
    {
        id: "00000000-0000-0000-0000-000000000034",
        name: "Telecommunications",
        key: "contractingServiceTelecommunications"
    },
    {
        id: "00000000-0000-0000-0000-000000000035",
        name: "Pipeline Installation / Maintenance",
        key: "contractingServicePipelineInstallationMaintenance"
    },
    {
        id: "00000000-0000-0000-0000-000000000036",
        name: "Tree Services",
        key: "contractingServiceTreeServices"
    },
    {
        id: "00000000-0000-0000-0000-000000000037",
        name: "Plumbing",
        key: "contractingServicePlumbing"
    },
    {
        id: "00000000-0000-0000-0000-000000000038",
        name: "Utility – Sewer",
        key: "contractingServiceUtilitySewer"
    },
    {
        id: "00000000-0000-0000-0000-000000000040",
        name: "Roofing",
        key: "contractingServiceRoofing"
    },
    {
        id: "00000000-0000-0000-0000-000000000041",
        name: "Other (please describe)",
        key: "contractingServiceOtherLabel"
    },
    {
        id: "00000000-0000-0000-0000-000000000042",
        name: "Solar and Alternative Energy",
        key: "contractingServiceSolarAndAlternativeEnergy"
    }
]

export const annualConstructionPercentage = [
    {
        id: "00000000-0000-0000-0000-000000000001",
        name: "Construction only",
        key: "annualConstructionValueConstructionOnly"
    },
    {
        id: "00000000-0000-0000-0000-000000000002",
        name: "Design-Build with design subcontracted",
        key: "annualConstructionValueDesignBuildWithDesignSubcontracted"
    },
    {
        id: "00000000-0000-0000-0000-000000000003",
        name: "Construction Management at Risk",
        key: "annualConstructionValueConstructionManagementAtRisk"
    },
    {
        id: "00000000-0000-0000-0000-000000000004",
        name: "Design-Build with in-house design",
        key: "annualConstructionValueDesignBuildWithInHouseDesign"
    },
    {
        id: "00000000-0000-0000-0000-000000000005",
        name: "Construction Management Agency",
        key: "annualConstructionValueConstructionManagementAgency"
    },
    {
        id: "00000000-0000-0000-0000-000000000006",
        name: "Engineer/Procure/Construct",
        key: "annualConstructionValueEngineerProcureConstruct"
    },
    {
        id: "00000000-0000-0000-0000-000000000007",
        name: "Design Only",
        key: "annualConstructionValueDesignOnly"
    },
    {
        id: "00000000-0000-0000-0000-000000000008",
        name: "Other (please describe)",
        key: "annualConstructionValueOtherLabel"
    }
]

export const estimatedPercentageOfCompanyTotalRevenue = [
    {
        id: "00000000-0000-0000-0000-000000000001",
        name: "Apartments/Condominiums (other than wood frame construction)",
        key: "companyTotalRevenueApartmentsCondominiumsOtherThanWoodFrame"
    },
    {
        id: "00000000-0000-0000-0000-000000000002",
        name: "Pipeline",
        key: "companyTotalRevenuePipeline"
    },
    {
        id: "00000000-0000-0000-0000-000000000003",
        name: "Apartments/Condominiums (wood frame construction)",
        key: "companyTotalRevenueApartmentsCondominiumsWoodFrame"
    },
    {
        id: "00000000-0000-0000-0000-000000000004",
        name: "Stadium & Arena",
        key: "companyTotalRevenueStadiumArena"
    },
    {
        id: "00000000-0000-0000-0000-000000000005",
        name: "Single Family Homes",
        key: "companyTotalRevenueSingleFamilyHomes"
    },
    {
        id: "00000000-0000-0000-0000-000000000006",
        name: "Paving – Street & Road",
        key: "companyTotalRevenuePavingStreetRoad"
    },
    {
        id: "00000000-0000-0000-0000-000000000007",
        name: "Hospitals/Healthcare",
        key: "companyTotalRevenueHospitalsHealthcare"
    },
    {
        id: "00000000-0000-0000-0000-000000000008",
        name: "Highway/Bridge",
        key: "companyTotalRevenueHighwayBridge"
    },
    {
        id: "00000000-0000-0000-0000-000000000009",
        name: "Hotels/Motels (other than wood frame construction)",
        key: "companyTotalRevenueHotelsMotelsOtherThanWoodFrame"
    },
    {
        id: "00000000-0000-0000-0000-000000000010",
        name: "Water/Waste Treatment",
        key: "companyTotalRevenueWaterWasteTreatment"
    },
    {
        id: "00000000-0000-0000-0000-000000000011",
        name: "Hotels/Motels (wood frame construction)",
        key: "companyTotalRevenueHotelsMotelsWoodFrame"
    },
    {
        id: "00000000-0000-0000-0000-000000000012",
        name: "Utility – Sewer & Water",
        key: "companyTotalRevenueUtilitySewerWater"
    },
    {
        id: "00000000-0000-0000-0000-000000000013",
        name: "Landfills",
        key: "companyTotalRevenueLandfills"
    },
    {
        id: "00000000-0000-0000-0000-000000000014",
        name: "Primary Education",
        key: "companyTotalRevenuePrimaryEducation"
    },
    {
        id: "00000000-0000-0000-0000-000000000015",
        name: "Parking Structures",
        key: "companyTotalRevenueParkingStructures"
    },
    {
        id: "00000000-0000-0000-0000-000000000016",
        name: "Colleges",
        key: "companyTotalRevenueColleges"
    },
    {
        id: "00000000-0000-0000-0000-000000000017",
        name: "Commercial Office or Retail",
        key: "companyTotalRevenueCommercialOfficeOrRetail"
    },
    {
        id: "00000000-0000-0000-0000-000000000018",
        name: "Industrial/Manufacturing",
        key: "companyTotalRevenueIndustrialManufacturing"
    },
    {
        id: "00000000-0000-0000-0000-000000000019",
        name: "Energy",
        key: "companyTotalRevenueEnergy"
    },
    {
        id: "00000000-0000-0000-0000-000000000020",
        name: "Other (please describe)",
        key: "companyTotalRevenueOtherLabel"
    }
]

export const isApplicationStatusInChangeList = (applicationStatus, currentStatus) => {
    if (!currentStatus) return false
    return (applicationStatus || []).some(
        (s) => s.name === currentStatus || s.value === currentStatus
    )
}

export const getApplicationStatusSelectValue = (applicationStatus, currentStatus) => {
    return isApplicationStatusInChangeList(applicationStatus, currentStatus) ? currentStatus : ""
}
